import { getAccountingUser } from '_services';
import { useEffect, useState, useCallback, useRef } from 'react';
import StorageService from 'utils/StorageServices';

const useAccountList = ({ autoFetch = true } = {}) => {
  const [accounts, setAccounts] = useState([]);
  const [loading, setLoading] = useState(autoFetch);
  const currentFirmId = useRef(StorageService?.getFirmId())

  const fetchAccounts = useCallback(async () => {
    setLoading(true);
    try {
      const res = await getAccountingUser({
        company_id: StorageService?.getCompanyId(),
        firm_id: currentFirmId.current || ""
      });

      if (res?.responseCode === 200) {
        setAccounts(res?.data?.chart_of_account);
      } else {
        console.log(res?.responseMessage);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    if (autoFetch) {
      fetchAccounts();
    }
  }, [autoFetch, fetchAccounts]);

  return {
    accounts,
    setAccounts,
    loading,
    refresh: fetchAccounts,
  };
};


export default useAccountList